<template>
    <a @click="toggleVerified">
        {{ this.isVerified ? this.setUnverifiedLabel : this.setVerifiedLabel }}
    </a>
</template>

<script>
    export default {
        props: {
            subscription: String,
            initialIsVerified: Boolean,
            setVerifiedLabel: String,
            setUnverifiedLabel: String,
            route: String,
            setVerifiedHandler: Function,
        },
        data: function () {
            return {
                isVerified: this.initialIsVerified
            }
        },
        methods: {
            setVerified() {
                this.setVerifiedHandler(this.subscription, this.isVerified);
            },
            toggleVerified () {
                if(this.route) {
                    axios.post(this.route, {
                        'item' : this.subscription
                    }).then(response => {
                        this.isVerified = response.data.is_on;
                        this.setVerified();
                    }).catch(function (error) {
                        // error management?
                        console.log(error);
                    });
                }
            }
        },
        mounted: function() {
            this.setVerified()
        }
    };
</script>
